const colourLibAction = {
  FETCH_COLORS: 'FETCH_COLORS',
  FETCH_COLORS_GROUP: 'FETCH_COLORS_GROUP',
  FETCH_COLORS_GROUP_EDIT: 'FETCH_COLORS_GROUP_EDIT',
  ADD_COLORS: 'ADD_COLORS',
  ADD_COLORS_GROUP: 'ADD_COLORS_GROUP',
  EDIT_COLORS: 'EDIT_COLORS',
  EDIT_COLORS_GROUP: 'EDIT_COLORS_GROUP',
  DELETE_COLORS: 'DELETE_COLORS',
  DELETE_COLORS_GROUPS: 'DELETE_COLORS_GROUPS',
  DESABLE_COLOR: 'DESABLE_COLOR',
  EMPTY_REDUCER: 'EMPTY_REDUCER',
  CLEAR_DOCUMENTS: 'CLEAR_DOCUMENTS',
  FETCH_OPTIONS: 'FETCH_OPTIONS',
  FETCH_COLORS_SUPPORTING_DOCUMENTS: 'FETCH_COLORS_SUPPORTING_DOCUMENTS',
  EDIT_SUPPORTING_DOCUMENTS: 'EDIT_SUPPORTING_DOCUMENTS',
  MERGED_PDF_PREVIEW: ' MERGED_PDF_PREVIEW',
  MERGED_PDF_DELETE: ' MERGED_PDF_DELETE',
  REMOVE_COLOUR_SUPPORTING_DOCUMENTS: 'REMOVE_COLOUR_SUPPORTING_DOCUMENTS',
  FETCH_COLORS_LIST: 'FETCH_COLORS_LIST',
  FETCH_COLORS_GROUP_LIST: 'FETCH_COLORS_GROUP_LIST',
  FETCH_COLOUR_GROUP_PAGINATION: 'FETCH_COLOUR_GROUP_PAGINATION',
};

export default colourLibAction;
